import React from 'react'
import {
  Section,
  SectionHeader,
  SectionBody,
  Table,
} from '@apexinternal/ui-components'
import { Text, Box } from '@chakra-ui/react'
import { isEmpty, lowerCase, startCase, values, without } from 'lodash'
import { InterestedParties } from 'types'
import { sentenceCase } from '../../utils'

export interface InterestedPartiesProps {
  interestedParties?: InterestedParties[]
}

const columns = [
  {
    key: 'name',
    label: 'Name',
    recordField: 'name',
    isSortable: false,
    width: '33%',
  },
  {
    key: 'additionalName',
    label: 'Additional Name',
    recordField: 'additionalName',
    isSortable: false,
    width: '33%',
  },
  {
    key: 'mailingAddress',
    label: 'Mailing Address',
    recordField: 'mailingAddress',
    isSortable: false,
    width: '33%',
  },
]

const InterestedPartiesTable = ({
  interestedParties,
}: InterestedPartiesProps) => {
  if (!interestedParties || isEmpty(interestedParties)) return null

  const data = interestedParties.map(
    ({ name, additionalName, mailingAddress }, index) => {
      const formattedName = sentenceCase(
        [name.givenName, name.middleInitial, name.familyName].join(' ')
      )
      const formattedCompanyName = sentenceCase(name.companyName)
      const formattedAdditionalName = sentenceCase(additionalName)
      const addressLine1 = sentenceCase(mailingAddress.streetAddress.join(' '))
      const addressLine2 = without(
        values({
          city: mailingAddress.city
            ? startCase(lowerCase(mailingAddress.city)) + ','
            : '',
          state: mailingAddress.state,
          postalCode: mailingAddress.postalCode,
          country: mailingAddress.country,
        })
      ).join(' ')

      const formattedAddress = (
        <Box>
          <Text>{addressLine1}</Text>
          <Text>{addressLine2}</Text>
        </Box>
      )
      const formattedNames = (
        <Box>
          {formattedName && <Text>{formattedName}</Text>}
          {formattedCompanyName && <Text>{formattedCompanyName}</Text>}
        </Box>
      )

      return {
        key: index,
        name: formattedNames,
        additionalName: formattedAdditionalName,
        mailingAddress: formattedAddress,
      }
    }
  )

  return (
    <Section pt="2rem" width="100%">
      <SectionHeader>Interested Parties</SectionHeader>
      <SectionBody>
        {data && !isEmpty(data) && (
          <Table
            columns={columns}
            variant="simple"
            // @ts-ignore The table component does not accept JSX.Element type
            data={data}
            defaultSort={{ field: 'name', ascending: true }}
          />
        )}
      </SectionBody>
    </Section>
  )
}

export default InterestedPartiesTable
